import React from 'react'
import AddIcon from '@material-ui/icons/Add'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import AttachFileIcon from '@material-ui/icons/AttachFile'
import PaymentIcon from '@material-ui/icons/Payment'
import SubjectIcon from '@material-ui/icons/Subject'
import type { TabValue } from './types'
import type { usePainterJobCardStyles } from './usePainterJobCardStyles'
import classNames from 'classnames'

export type JobAddActionTab = Extract<TabValue, 'files' | 'tasks' | 'notes'>

interface JobAddActionMenuProps {
  canAddAdditionalWork: boolean
  showTasksNotesFiles: boolean
  showPayments: boolean
  paymentsDisabled?: boolean
  onAddAdditionalWork: () => void
  onAddFile: () => void
  onAddTask: () => void
  onAddNote: () => void
  onAddPayment: () => void
  classes: ReturnType<typeof usePainterJobCardStyles>
}

export default function JobAddActionMenu(props: JobAddActionMenuProps) {
  const {
    canAddAdditionalWork,
    showTasksNotesFiles,
    showPayments,
    paymentsDisabled,
    onAddAdditionalWork,
    onAddFile,
    onAddTask,
    onAddNote,
    onAddPayment,
    classes
  } = props
  return (
    <div className={classes.addActionMenu}>
      {canAddAdditionalWork && (
        <button type="button" className={classes.addActionMenuItem} onClick={onAddAdditionalWork}>
          <AddIcon className={classes.addActionMenuIcon} />
          Additional Work
        </button>
      )}
      {showTasksNotesFiles && (
        <button type="button" className={classes.addActionMenuItem} onClick={onAddFile}>
          <AttachFileIcon className={classes.addActionMenuIcon} />
          Files
        </button>
      )}
      {showTasksNotesFiles && (
        <button type="button" className={classes.addActionMenuItem} onClick={onAddTask}>
          <AssignmentTurnedInIcon className={classes.addActionMenuIcon} />
          Tasks
        </button>
      )}
      {showTasksNotesFiles && (
        <button type="button" className={classes.addActionMenuItem} onClick={onAddNote}>
          <SubjectIcon className={classes.addActionMenuIcon} />
          Notes
        </button>
      )}
      {showPayments && (
        <button
          type="button"
          className={classNames({
            [classes.addActionMenuItem]: true,
            [classes.addActionMenuItemDisabled]: paymentsDisabled
          })}
          onClick={onAddPayment}
        >
          <PaymentIcon className={classes.addActionMenuIcon} />
          Payments
        </button>
      )}
    </div>
  )
}
